import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgSuitcaseFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M28.158 14.84c-.85 0-1.54-.704-1.54-1.571v-2.356h-6.16v2.356c0 .867-.69 1.57-1.54 1.57-.85 0-1.54-.703-1.54-1.57v-2.356c0-1.733 1.381-3.142 3.08-3.142h6.16c1.699 0 3.08 1.41 3.08 3.142v2.356c0 .867-.69 1.57-1.54 1.57Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.292 12.484h28.49c2.342 0 4.236 1.932 4.236 4.32v5.106h-9.24v-1.964c0-.644-.524-1.178-1.155-1.178-.632 0-1.155.534-1.155 1.178v1.963h-13.86v-1.963c0-.644-.524-1.178-1.156-1.178-.631 0-1.155.534-1.155 1.178v1.963h-9.24v-5.105c0-2.387 1.894-4.32 4.235-4.32Zm23.486 13.227v-1.445h9.24v10.603c0 2.388-1.894 4.32-4.235 4.32H9.292c-2.341 0-4.235-1.932-4.235-4.32V24.266h9.24v1.445c0 .644.524 1.178 1.155 1.178.632 0 1.155-.534 1.155-1.178v-1.445h13.86v1.445c0 .644.524 1.178 1.156 1.178.631 0 1.155-.534 1.155-1.178Z"
            />
        </svg>
    )
}
SvgSuitcaseFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgSuitcaseFill
